/* ==========================================================================
   WAENN — Scroll "por secciones" (fullpage), SOLO en portada (template-index)
   ==========================================================================
   Se carga condicionalmente solo cuando template == 'index' (ver
   layout/theme.liquid). Envuelve en tiempo real las secciones que ya
   renderiza Shopify dentro de #MainContent (Dawn OS2.0 no trae de fabrica
   ningun contenedor "fullpage": lo construye este script, sin asumir un
   numero fijo de secciones, para que siga funcionando si se anaden,
   quitan o reordenan secciones desde el editor de temas).

   Punto de partida real de la tienda (comprobado antes de escribir esto):
     - layout/theme.liquid renderiza `{{ content_for_layout }}` dentro de
       `<main id="MainContent" class="content-for-layout focus-none">`.
     - Cada seccion del home (templates/index.json) sale como un div
       hermano directo `<div id="shopify-section-..." class="shopify-section ...">`
       dentro de ese <main>. No hay wrapper propio que agrupe "las
       secciones del home": lo crea este script (`.section-scroll-track`).
     - En portada, el header y la barra de anuncio ya van con
       position:fixed y flotan ENCIMA del contenido (ver
       assets/waenn-header-overlay.css), asi que cada seccion a pantalla
       completa mide 100vh/100dvh desde y=0, exactamente igual que antes.
     - El FOOTER (newsletter + columnas + banda negra WAENN) vive FUERA de
       #MainContent (renderizado aparte en layout/theme.liquid), asi que
       nunca forma parte de "state.sections" ni del carril fullpage.

   Comportamiento:
     - Activo SOLO si: estamos en template-index, NO estamos dentro del
       editor de temas (Shopify.designMode), el usuario no tiene activado
       "reducir movimiento", y el ancho de pantalla es >= BREAKPOINT (salvo
       que se active ENABLE_ON_MOBILE).
     - Si JS no llega a ejecutarse por cualquier motivo, la pagina se queda
       con scroll normal: no hay ningun estado intermedio roto.
     - Al llegar a la ULTIMA seccion e intentar seguir avanzando (rueda,
       swipe o flecha abajo), el efecto se libera por completo y la pagina
       pasa a scroll normal, saltando directamente al footer -- antes,
       html/body quedaban con overflow:hidden todo el rato que el efecto
       estaba activo, asi que pasada la ultima seccion no habia forma de
       llegar al footer (quedaba scroll bloqueado, footer inalcanzable:
       el bug que reporto WAENN, sobre todo notorio en movil).

   FIX (v2) — carrusel horizontal de looks inactivo en el primer scroll:
     Sintoma reportado por WAENN: al llegar por primera vez a la seccion
     del carrusel de looks (assets/waenn-looks-carousel.js, que usa scroll
     horizontal NATIVO del navegador -- overflow-x:auto + scroll-snap-type:
     x mandatory sobre [data-waenn-looks], SIN ningun listener de wheel
     propio) el usuario podia hacer click en un look pero no desplazarse
     horizontalmente. Si continuaba bajando hasta el final de la portada y
     volvia a subir, el carrusel funcionaba con normalidad.

     Causa raiz real (no un simple "no ha cargado a tiempo"): handleWheel
     (y handleTouchMove/handleTouchEnd) de aqui abajo miraban UNICAMENTE
     e.deltaY para decidir si el gesto debia cambiar de seccion, ignorando
     por completo e.deltaX. La seccion del carrusel no tiene scroll
     VERTICAL propio (mide exactamente 100vh y no tiene overflow-y), asi
     que atSectionEdge() daba siempre "true" fuera cual fuera la
     direccion -- y por tanto CUALQUIER evento wheel sobre esa seccion,
     incluido un gesto puramente horizontal de trackpad (deltaX != 0,
     deltaY ~ 0) disparaba e.preventDefault(). preventDefault() en un
     wheel event cancela la accion por defecto del evento completo (que es
     "el navegador decide que ancestro con overflow puede desplazarse en
     esa direccion y lo desplaza"), asi que el scroll horizontal nativo
     del carrusel quedaba bloqueado de raiz -- solo sobrevivia el click,
     que este listener nunca tocaba.

     Por que "se arreglaba solo" al llegar al final y volver a subir: al
     superar la ultima seccion, releaseToFooter() marca
     state.footerReleased = true y llama a disable(), que hace
     window.removeEventListener('wheel', handleWheel) de forma
     PERMANENTE para el resto de la sesion en esa pagina (shouldEnable()
     corta en seco si footerReleased es true). Sin ese listener global ya
     no hay nada interceptando el wheel, asi que el scroll horizontal
     nativo del carrusel (que nunca dependio de este script) volvia a
     funcionar sin mas.

     Fix real (no temporizador, no parche): handleWheel/handleTouchMove/
     handleTouchEnd ahora comparan la magnitud de ambos ejes del gesto y,
     si el gesto es predominantemente HORIZONTAL (|deltaX| > |deltaY|),
     lo dejan pasar de largo sin tocarlo -- ni preventDefault, ni se
     cuenta como intento de cambiar de seccion. Este control de "cambiar
     de seccion" solo debe reaccionar ante intencion vertical real; un
     gesto horizontal nunca es "hemos llegado al borde de la seccion y
     hay que pasar a la siguiente", es scroll nativo de un descendiente
     (el carrusel, o cualquier otro elemento con overflow-x en el futuro)
     y el navegador ya sabe dirigirlo solo si no se le prohibe con
     preventDefault(). Esto no depende de conocer el carrusel: cualquier
     seccion futura con contenido horizontal se beneficia igual, sin
     tocar este archivo de nuevo.

   FIX (v3) — el panel "Ver el look" (a pantalla completa, ver
     assets/waenn-looks-carousel.js/.css) hacia scroll del FONDO en vez de
     su propio contenido en movil: isOverlayOpen() de aqui abajo ya
     pausaba este efecto con el carrito, el menu movil y el buscador
     abiertos, pero no conocia el panel "Ver el look" (que se saca fuera
     de la seccion, al final de <body>, precisamente para huir de este
     mismo carril con transform). Con la portada activa, cualquier swipe
     dentro del panel seguia llegando a handleTouchMove/handleTouchEnd de
     aqui (listeners en window, no dentro del panel) y, al no detectar el
     panel como "overlay abierto", desplazaba el transform de fondo
     (state.track) en vez de dejar que el navegador hiciera scroll normal
     dentro de .waenn-look-panel__inner. Se anade el panel a la misma
     comprobacion que el resto de overlays.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Configuracion
     --------------------------------------------------------------------- */

  // Ancho por debajo del cual, si ENABLE_ON_MOBILE fuera false, el efecto
  // se desactivaria. WAENN pidio explicitamente activar tambien el scroll
  // automatico de pantalla completa en movil (antes desactivado por los
  // riesgos ya documentados aqui debajo: barra de direccion cambiando el
  // 100vh en tiempo real, gestos de pull-to-refresh de iOS peleando con
  // preventDefault, sensacion de swipe "atascado"). Se activa ahora con
  // ENABLE_ON_MOBILE = true; el uso real en dispositivos (sobre todo iOS)
  // dira si hace falta afinar mas los umbrales de gesto de aqui abajo.
  var BREAKPOINT = 768;
  var ENABLE_ON_MOBILE = true;

  // Debe coincidir con la duracion de "transition" de .section-scroll-track
  // en section-scroll-snap.css.
  var TRANSITION_MS = 820;
  // Margen de seguridad sobre TRANSITION_MS antes de aceptar el siguiente
  // gesto (evita que un scroll rapido dispare 2-3 secciones seguidas).
  var COOLDOWN_MS = 900;

  // Cuanto "deltaY" acumulado de rueda/trackpad hace falta para disparar
  // un cambio de seccion (evita que un trackpad, que manda docenas de
  // eventos wheel muy pequenos por gesto, dispare de mas).
  var WHEEL_THRESHOLD = 45;
  // Cuantos px de swipe tactil hacen falta para contar como gesto de
  // cambio de seccion.
  var TOUCH_THRESHOLD = 60;

  /* ---------------------------------------------------------------------
     Estado
     --------------------------------------------------------------------- */

  var state = {
    enabled: false,
    track: null,
    sections: [],
    dotsEl: null,
    liveRegion: null,
    activeIndex: 0,
    isAnimating: false,
    wheelAccum: 0,
    touchStartY: null,
    touchStartX: null,
    touchActiveDirection: 0,
    lockTimer: null,
    resizeRAF: null,
    // Una vez el usuario ha "salido" del carril fullpage hacia el footer
    // (ver releaseToFooter), el efecto se queda desactivado para el resto
    // de la sesion en esta pagina -- si no, un simple evento de resize
    // (p.ej. la barra de direccion del movil aparece/desaparece al leer
    // el footer) volveria a activar el carril de golpe, con un salto
    // brusco hacia arriba mientras el usuario esta leyendo el footer.
    footerReleased: false
  };

  /* ---------------------------------------------------------------------
     Utilidades de contexto
     --------------------------------------------------------------------- */

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function inThemeEditorDesignMode() {
    // Dentro del editor de temas de Shopify, el "scroll por secciones"
    // estorba mas de lo que ayuda: el merchant necesita poder scrollear
    // libremente para hacer clic y editar cualquier seccion, y un scroll
    // que "secuestra" la rueda del raton se lo pondria dificil. Por eso
    // este efecto se queda desactivado mientras se esta editando el tema,
    // y solo se activa en la tienda publicada / vista previa real.
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function isHomeTemplate() {
    return document.body.classList.contains('template-index');
  }

  function shouldEnable() {
    if (state.footerReleased) return false;
    if (!isHomeTemplate()) return false;
    if (inThemeEditorDesignMode()) return false;
    if (prefersReducedMotion()) return false;
    if (!ENABLE_ON_MOBILE && window.innerWidth < BREAKPOINT) return false;
    return true;
  }

  function isOverlayOpen() {
    // Con el carrito, el menu movil, el buscador, "guardados" o el panel
    // "Ver el look" abiertos, el scroll/teclado tiene que comportarse con
    // normalidad dentro de esos paneles, no cambiar de seccion del home
    // por debajo.
    //
    // OJO: .search-modal NUNCA lleva el atributo "hidden" en este tema
    // (ver snippets del buscador) -- su visibilidad depende de si el
    // <details> nativo que lo envuelve (dentro de <details-modal
    // class="header__search">) tiene o no el atributo "open". Por eso
    // aqui se comprueba subiendo al <details> ancestro real, en vez de
    // usar ":not([hidden])" contra el propio .search-modal (esa version
    // anterior siempre daba "true" y bloqueaba permanentemente la rueda,
    // el teclado y el swipe -- bug detectado en pruebas antes de publicar).
    if (document.querySelector('.drawer.active')) return true;

    var menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
    if (menuDrawerDetails && menuDrawerDetails.hasAttribute('open')) return true;

    var searchModal = document.querySelector('.search-modal');
    if (searchModal) {
      var detailsAncestor = searchModal.closest('details');
      if (detailsAncestor && detailsAncestor.hasAttribute('open')) return true;
    }

    // Panel "Ver el look" (assets/waenn-looks-carousel.js): vive fuera de
    // la seccion, al final de <body>, y se muestra/oculta con la
    // propiedad nativa "hidden" (panel.hidden = false/true), nunca con
    // una clase -- de ahi la comprobacion ":not([hidden])" en vez de
    // ".active" como en el resto de overlays de aqui arriba.
    if (document.querySelector('[data-waenn-look-panel]:not([hidden])')) return true;

    return false;
  }

  function isTypingTarget(el) {
    if (!el) return false;
    var tag = el.tagName ? el.tagName.toLowerCase() : '';
    return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable;
  }

  function getMainContent() {
    return document.getElementById('MainContent');
  }

  function getFooterEl() {
    return (
      document.querySelector('.section-group-footer-group') ||
      document.querySelector('[id^="shopify-section-footer"]') ||
      document.querySelector('footer.footer') ||
      document.querySelector('footer')
    );
  }

  /* ---------------------------------------------------------------------
     Construccion de la interfaz (puntos + region viva para lectores de
     pantalla)
     --------------------------------------------------------------------- */

  function sectionLabel(section, index) {
    var heading = section.querySelector('h1, h2, h3');
    var text = heading && heading.textContent ? heading.textContent.trim() : '';
    if (text) return text;
    return 'Seccion ' + (index + 1);
  }

  function buildLiveRegion() {
    var live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    live.id = 'SectionScrollLiveRegion';
    document.body.appendChild(live);
    state.liveRegion = live;
  }

  function announce(index) {
    if (!state.liveRegion) return;
    var label = sectionLabel(state.sections[index], index);
    state.liveRegion.textContent =
      label + ' (' + (index + 1) + ' de ' + state.sections.length + ')';
  }

  function buildDots() {
    var nav = document.createElement('nav');
    nav.className = 'section-scroll-dots';
    nav.setAttribute('aria-label', 'Navegacion entre secciones de la portada');

    state.sections.forEach(function (section, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Ir a: ' + sectionLabel(section, i));
      btn.setAttribute('aria-current', i === state.activeIndex ? 'true' : 'false');
      btn.addEventListener('click', function () {
        goToSection(i);
      });
      nav.appendChild(btn);
    });

    document.body.appendChild(nav);
    state.dotsEl = nav;
  }

  function updateDots() {
    if (!state.dotsEl) return;
    var buttons = state.dotsEl.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-current', i === state.activeIndex ? 'true' : 'false');
    }
  }

  /* ---------------------------------------------------------------------
     Movimiento entre secciones
     --------------------------------------------------------------------- */

  function setTranslate() {
    if (!state.track) return;
    // OJO: se usa 'dvh' (alto de viewport DINAMICO, se ajusta en tiempo
    // real si la barra de direccion del navegador movil aparece/desaparece)
    // en vez de 'vh' (alto de viewport GRANDE, fijo, ignora la barra de
    // direccion). Las secciones en si miden 100dvh (ver .shopify-section
    // en section-scroll-snap.css); si aqui se desplazara con 'vh' en vez
    // de 'dvh', ambos valores no coincidirian exactamente mientras la
    // barra de direccion esta visible (vh > dvh en ese momento), y el
    // desplazamiento resultante quedaria mas corto o mas largo que el
    // alto real de cada seccion -- dejando asomar un trozo de la seccion
    // siguiente por abajo antes de completar el gesto de scroll (bug
    // reportado por WAENN en movil). Usando la misma unidad en los dos
    // sitios, el desplazamiento coincide siempre con el alto real visible.
    state.track.style.transform = 'translateY(-' + state.activeIndex * 100 + 'dvh)';
  }

  function isAtLastSection() {
    return state.activeIndex >= state.sections.length - 1;
  }

  function goToSection(index) {
    if (!state.enabled) return;
    index = Math.max(0, Math.min(state.sections.length - 1, index));
    if (index === state.activeIndex || state.isAnimating) return;

    state.isAnimating = true;
    state.activeIndex = index;

    setTranslate();
    updateDots();
    announce(index);

    // Reinicia el scroll interno de la seccion de destino y mueve el foco
    // ahi, para que teclado y lectores de pantalla sigan la navegacion.
    var target = state.sections[index];
    target.scrollTop = 0;
    if (typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }

    window.clearTimeout(state.lockTimer);
    state.lockTimer = window.setTimeout(function () {
      state.isAnimating = false;
      state.wheelAccum = 0;
    }, COOLDOWN_MS);
  }

  // Se llama cuando el usuario, ya en la ultima seccion, intenta seguir
  // avanzando (rueda hacia abajo, swipe hacia arriba, o flecha abajo).
  // Libera el efecto fullpage por completo (disable(), mas abajo) y salta
  // el scroll normal directamente al footer -- sin este salto explicito,
  // el usuario apareceria de golpe arriba del todo (top:0), porque
  // mientras el efecto estaba activo el body tenia overflow:hidden y su
  // scrollTop real se quedaba siempre en 0.
  function releaseToFooter() {
    state.footerReleased = true;
    disable();
    window.requestAnimationFrame(function () {
      var footer = getFooterEl();
      if (footer && typeof footer.scrollIntoView === 'function') {
        footer.scrollIntoView({ behavior: 'auto', block: 'start' });
      } else {
        window.scrollTo(0, document.body.scrollHeight);
      }
    });
  }

  function atSectionEdge(direction) {
    // direction > 0 => intentando avanzar (scroll hacia abajo / swipe arriba)
    // direction < 0 => intentando retroceder
    var section = state.sections[state.activeIndex];
    if (!section) return true;

    var atTop = section.scrollTop <= 1;
    var atBottom = section.scrollTop + section.clientHeight >= section.scrollHeight - 1;

    return direction > 0 ? atBottom : atTop;
  }

  /* ---------------------------------------------------------------------
     Eventos: rueda / trackpad
     --------------------------------------------------------------------- */

  function handleWheel(e) {
    if (!state.enabled || isOverlayOpen()) return;

    // Gesto predominantemente HORIZONTAL (trackpad deslizando a los
    // lados, shift+rueda, etc.): no es una intencion de cambiar de
    // seccion, es scroll nativo de algun descendiente con overflow-x
    // (p.ej. el carrusel de looks, [data-waenn-looks]). Se deja pasar sin
    // tocar -- ni se acumula en wheelAccum ni se llama a preventDefault --
    // para que el navegador lo dirija el solo al elemento scrollable que
    // corresponda. Ver nota "FIX (v2)" en la cabecera del archivo: antes
    // esta funcion solo miraba deltaY, y como la seccion del carrusel no
    // tiene scroll vertical propio (atSectionEdge() daba siempre true),
    // CUALQUIER gesto sobre ella -- incluido uno puramente horizontal --
    // acababa en preventDefault(), matando el scroll horizontal nativo.
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    var direction = e.deltaY > 0 ? 1 : -1;

    if (!atSectionEdge(direction)) {
      // La seccion activa todavia tiene contenido propio por scrollear:
      // se deja el scroll interno normal, sin tocar el efecto fullpage.
      return;
    }

    // Ya estamos en el borde de la seccion: cualquier scroll adicional en
    // esa direccion tiene que cambiar de seccion, no salirse del viewport.
    e.preventDefault();

    if (state.isAnimating) return;

    state.wheelAccum += e.deltaY;
    if (Math.abs(state.wheelAccum) < WHEEL_THRESHOLD) return;

    if (direction > 0 && isAtLastSection()) {
      releaseToFooter();
      return;
    }

    goToSection(state.activeIndex + direction);
  }

  /* ---------------------------------------------------------------------
     Eventos: teclado
     --------------------------------------------------------------------- */

  function handleKeydown(e) {
    if (!state.enabled || isOverlayOpen()) return;
    if (isTypingTarget(document.activeElement)) return;

    if (e.key === 'Home') {
      e.preventDefault();
      goToSection(0);
      return;
    }
    if (e.key === 'End') {
      e.preventDefault();
      goToSection(state.sections.length - 1);
      return;
    }

    var direction = 0;
    if (e.key === 'ArrowDown' || e.key === 'PageDown') direction = 1;
    else if (e.key === 'ArrowUp' || e.key === 'PageUp') direction = -1;
    else return;

    if (!atSectionEdge(direction)) return;

    e.preventDefault();

    if (direction > 0 && isAtLastSection()) {
      releaseToFooter();
      return;
    }

    goToSection(state.activeIndex + direction);
  }

  /* ---------------------------------------------------------------------
     Eventos: tactil (swipe)
     --------------------------------------------------------------------- */

  function handleTouchStart(e) {
    if (!state.enabled || isOverlayOpen()) return;
    state.touchStartY = e.touches[0].clientY;
    state.touchStartX = e.touches[0].clientX;
  }

  function handleTouchMove(e) {
    if (!state.enabled || isOverlayOpen() || state.touchStartY === null) return;

    var currentY = e.touches[0].clientY;
    var currentX = e.touches[0].clientX;
    var deltaY = state.touchStartY - currentY; // positivo = dedo sube = avanzar
    var deltaX = state.touchStartX - currentX;
    var direction = deltaY > 0 ? 1 : -1;

    // Mismo criterio que en handleWheel: un swipe predominantemente
    // horizontal (dedo deslizando el carrusel de looks) no es un intento
    // de cambiar de seccion y nunca debe bloquearse con preventDefault,
    // por poco que se haya movido en vertical mientras tanto.
    if (Math.abs(deltaX) > Math.abs(deltaY)) return;

    // Solo bloquea el scroll nativo (rebote/pull-to-refresh) cuando el
    // gesto realmente va a provocar un cambio de seccion; si la seccion
    // aun tiene recorrido interno, se deja el swipe normal.
    if (Math.abs(deltaY) > 10 && atSectionEdge(direction)) {
      e.preventDefault();
    }
  }

  function handleTouchEnd(e) {
    if (!state.enabled || isOverlayOpen() || state.touchStartY === null) return;

    var endY = e.changedTouches[0].clientY;
    var endX = e.changedTouches[0].clientX;
    var deltaY = state.touchStartY - endY;
    var deltaX = state.touchStartX - endX;
    state.touchStartY = null;
    state.touchStartX = null;

    // Igual que arriba: un gesto que termino siendo predominantemente
    // horizontal fue un swipe del carrusel, no un cambio de seccion.
    if (Math.abs(deltaX) > Math.abs(deltaY)) return;

    if (Math.abs(deltaY) < TOUCH_THRESHOLD || state.isAnimating) return;

    var direction = deltaY > 0 ? 1 : -1;
    if (!atSectionEdge(direction)) return;

    if (direction > 0 && isAtLastSection()) {
      releaseToFooter();
      return;
    }

    goToSection(state.activeIndex + direction);
  }

  /* ---------------------------------------------------------------------
     Alta / baja del efecto (permite activarlo y desactivarlo en caliente
     al cruzar el breakpoint movil, sin recargar la pagina)
     --------------------------------------------------------------------- */

  function enable() {
    var main = getMainContent();
    if (!main) return;

    var children = Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });

    // Con 0 o 1 seccion no hay nada que paginar.
    if (children.length < 2) return;

    var track = document.createElement('div');
    track.className = 'section-scroll-track';

    children.forEach(function (child) {
      child.setAttribute('tabindex', '-1');
      track.appendChild(child);
    });

    main.appendChild(track);

    state.track = track;
    state.sections = children;
    state.activeIndex = 0;
    state.enabled = true;

    document.documentElement.classList.add('section-scroll-active');

    setTranslate();
    buildDots();
    buildLiveRegion();

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('keydown', handleKeydown);
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd, { passive: true });
  }

  function disable() {
    window.removeEventListener('wheel', handleWheel);
    window.removeEventListener('keydown', handleKeydown);
    window.removeEventListener('touchstart', handleTouchStart);
    window.removeEventListener('touchmove', handleTouchMove);
    window.removeEventListener('touchend', handleTouchEnd);

    if (state.track) {
      var main = getMainContent();
      var track = state.track;
      var parent = track.parentNode || main;
      while (track.firstChild) {
        track.firstChild.removeAttribute('tabindex');
        parent.insertBefore(track.firstChild, track);
      }
      parent.removeChild(track);
    }

    if (state.dotsEl && state.dotsEl.parentNode) {
      state.dotsEl.parentNode.removeChild(state.dotsEl);
    }
    if (state.liveRegion && state.liveRegion.parentNode) {
      state.liveRegion.parentNode.removeChild(state.liveRegion);
    }

    document.documentElement.classList.remove('section-scroll-active');

    window.clearTimeout(state.lockTimer);

    state.enabled = false;
    state.track = null;
    state.sections = [];
    state.dotsEl = null;
    state.liveRegion = null;
    state.activeIndex = 0;
    state.isAnimating = false;
    state.wheelAccum = 0;
  }

  /* ---------------------------------------------------------------------
     Ciclo de vida
     --------------------------------------------------------------------- */

  function handleResize() {
    if (state.footerReleased) return;
    window.cancelAnimationFrame(state.resizeRAF);
    state.resizeRAF = window.requestAnimationFrame(function () {
      var wants = shouldEnable();
      if (wants && !state.enabled) {
        enable();
      } else if (!wants && state.enabled) {
        disable();
      } else if (state.enabled) {
        // Sigue activo: solo hace falta re-situar el carril por si el
        // alto de viewport cambio (rotacion de pantalla, barra de
        // direccion, etc.).
        setTranslate();
      }
    });
  }

  function init() {
    if (shouldEnable()) enable();
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
